module.exports = __webpack_public_path__ + "img/contact_introduction.5a98bdbc.png";